import { faAngleLeft, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../hooks";
import { AuthenticationContext } from "../../../providers/authentication/AuthenticationContext";
import { Button } from "../../atoms";
import HostedPagesProfileAvatar from "./HostedPagesProfileAvatar";

export type HostedPagesBackHeaderProps = {
  label: string;
  link?: string;
  onClose?: () => void;
  rightSideOptions?: React.ReactNode;
};

export const HostedPagesBackHeader = ({
  label,
  onClose,
  link,
  rightSideOptions,
}: HostedPagesBackHeaderProps) => {
  const { isEmbed } = usePortalRoutes();
  const auth = useContext(AuthenticationContext);
  const history = useHistory();
  return (
    <div className="bg-gray-0 flex h-fit w-full flex-row items-center justify-between gap-4 border-b border-gray-300 px-4 py-2 lg:px-28 dark:border-gray-700 dark:bg-gray-950">
      <div className="flex flex-row items-center justify-center gap-4">
        <Button
          intent="transparent"
          className="h-[1.875rem] min-h-0 min-w-0 p-1 lg:h-9"
          link={link}
          onClick={
            link
              ? undefined
              : () => {
                  history.goBack();
                }
          }
        >
          <FontAwesomeIcon
            icon={faAngleLeft}
            className="size-5 text-gray-500"
          />
        </Button>
        <div className="dark:text-gray-25 text-lg font-semibold text-gray-950 lg:text-xl">
          {label}
        </div>
      </div>
      {rightSideOptions}
      {!onClose && auth.userId && isEmbed && <HostedPagesProfileAvatar />}
      {onClose && (
        <Button
          onClick={() => {
            onClose();
          }}
          className="aspect-square size-10"
          intent="transparent"
        >
          <FontAwesomeIcon
            className="cursor-pointer text-xl text-gray-600"
            icon={faClose}
          />
        </Button>
      )}
    </div>
  );
};
